import {
    CATALOG_ROUTE,
    CHANGE_REQUESTS_ROUTE,
    DRAFTS_ROUTE,
    EDIT_ROUTE,
    RIGHTSHOLDER_SUB_ROUTES,
    STEP_ROUTES,
    VIEW_DRAFT_ROUTE,
    VIEW_ROUTE,
    VIEW_SUBMISSION_ROUTE,
    VIEW_TRANSACTION_ROUTE,
    VIEW_WORK_ROUTE,
} from '@App/navigation/route'
import { ID } from '@App/navigation/index'
import { createRootRightsholderRoute } from '@App/navigation/rightsholder-navigation-creatework'

const createRootEditRoute = (id: ID, type: string, workId: ID) =>
    `${createRootRightsholderRoute(id)}/${CATALOG_ROUTE}/${type}/${workId}/${EDIT_ROUTE}`
const createRootEditDraftRoute = (id: ID, type: string, workId: ID) =>
    `${createRootRightsholderRoute(id)}/${DRAFTS_ROUTE}/${type}/${workId}/${EDIT_ROUTE}`

export const catalogNavigation = (id: ID) => ({
    root: `${createRootRightsholderRoute(id)}/${RIGHTSHOLDER_SUB_ROUTES.catalog.root}`,
    work: (workId: ID) => `${createRootRightsholderRoute(id)}/${VIEW_WORK_ROUTE}/${workId}/${VIEW_ROUTE}`,
    changeRequests: {
        root: `${createRootRightsholderRoute(id)}/${RIGHTSHOLDER_SUB_ROUTES.catalog.changeRequests.root}`,
        view: (suggestionId: ID) =>
            `${createRootRightsholderRoute(id)}/${CATALOG_ROUTE}/${CHANGE_REQUESTS_ROUTE}/${suggestionId}`,
    },
    workEdit: {
        root: (type: string, workId: ID) => createRootEditRoute(id, type, workId),
        workDetails: (type: string, workId: ID) =>
            `${createRootEditRoute(id, type, workId)}/${STEP_ROUTES.workDetails}`,
        writers: (type: string, workId: ID) => `${createRootEditRoute(id, type, workId)}/${STEP_ROUTES.writers}`,
        writersSharesRole: (type: string, workId: ID) =>
            `${createRootEditRoute(id, type, workId)}/${STEP_ROUTES.writersShares}`,
        publishers: (type: string, workId: ID) => `${createRootEditRoute(id, type, workId)}/${STEP_ROUTES.publishers}`,
        publishersShares: (type: string, workId: ID) =>
            `${createRootEditRoute(id, type, workId)}/${STEP_ROUTES.publishersShares}`,
        recordings: (type: string, workId: ID) => `${createRootEditRoute(id, type, workId)}/${STEP_ROUTES.recordings}`,
        submission: (type: string, workId: ID) => `${createRootEditRoute(id, type, workId)}/${STEP_ROUTES.submission}`,
    },
})

export const registrationHistoryNavigation = (id: ID) => ({
    root: `${createRootRightsholderRoute(id)}/${RIGHTSHOLDER_SUB_ROUTES.registrationHistory.root}`,
    pending: `${createRootRightsholderRoute(id)}/${RIGHTSHOLDER_SUB_ROUTES.registrationHistory.root}#pending`,
    processed: `${createRootRightsholderRoute(id)}/${RIGHTSHOLDER_SUB_ROUTES.registrationHistory.root}#processed`,
    needsAttention: `${createRootRightsholderRoute(id)}/${RIGHTSHOLDER_SUB_ROUTES.registrationHistory.root}#needs-attention`,
    submission: (workId: ID) => `${createRootRightsholderRoute(id)}/${VIEW_SUBMISSION_ROUTE}/${workId}/${VIEW_ROUTE}`,
    transaction: (workId: ID) => `${createRootRightsholderRoute(id)}/${VIEW_TRANSACTION_ROUTE}/${workId}/${VIEW_ROUTE}`,
})

export const registrationDraftsNavigation = (id: ID) => ({
    root: `${createRootRightsholderRoute(id)}/${RIGHTSHOLDER_SUB_ROUTES.drafts.root}`,
    draft: (workId: ID) => `${createRootRightsholderRoute(id)}/${VIEW_DRAFT_ROUTE}/${workId}/${VIEW_ROUTE}`,
    editRoot: (type: string, workId: ID) => `${createRootEditDraftRoute(id, type, workId)}`,
    workDetails: (type: string, workId: ID) =>
        `${createRootEditDraftRoute(id, type, workId)}/${STEP_ROUTES.workDetails}`,
    writers: (type: string, workId: ID) => `${createRootEditDraftRoute(id, type, workId)}/${STEP_ROUTES.writers}`,
    writersSharesRole: (type: string, workId: ID) =>
        `${createRootEditDraftRoute(id, type, workId)}/${STEP_ROUTES.writersShares}`,
    publishers: (type: string, workId: ID) => `${createRootEditDraftRoute(id, type, workId)}/${STEP_ROUTES.publishers}`,
    publishersShares: (type: string, workId: ID) =>
        `${createRootEditDraftRoute(id, type, workId)}/${STEP_ROUTES.publishersShares}`,
    recordings: (type: string, workId: ID) => `${createRootEditDraftRoute(id, type, workId)}/${STEP_ROUTES.recordings}`,
    submission: (type: string, workId: ID) => `${createRootEditDraftRoute(id, type, workId)}/${STEP_ROUTES.submission}`,
})
